import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base URL
const BASE_URL =  process.env.REACT_APP_API_URL;

// Async thunk for fetching activity logs
export const fetchActivityLogs = createAsyncThunk(
  "activityLogs/fetchActivityLogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const {
        page = 1,
        page_size = 50,
        user_id = "",
        action = "",
        from_date = "",
        to_date = "",
      } = params;

      const queryParams = new URLSearchParams();
      queryParams.append("page", page);
      queryParams.append("page_size", page_size);
      
      if (user_id) queryParams.append("user_id", user_id);
      if (action) queryParams.append("action", action);
      if (from_date) queryParams.append("from_date", from_date);
      if (to_date) queryParams.append("to_date", to_date);

      const response = await axios.get(
        `${BASE_URL}/ActivityLogs/?${queryParams.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في جلب سجل الأنشطة"
      );
    }
  }
);

const activityLogsSlice = createSlice({
  name: "activityLogs",
  initialState: {
    logs: [],
    loading: false,
    error: null,
    pagination: {
      page: 1,
      page_size: 50,
      total_count: 0,
      has_next: false,
      has_previous: false,
    },
    filters: {
      user_id: "",
      action: "",
      from_date: "",
      to_date: "",
    },
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        user_id: "",
        action: "",
        from_date: "",
        to_date: "",
      };
    },
    setPage: (state, action) => {
      state.pagination.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActivityLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.logs;
        state.pagination = {
          page: action.payload.page,
          page_size: action.payload.page_size,
          total_count: action.payload.total_count,
          has_next: action.payload.page * action.payload.page_size < action.payload.total_count,
          has_previous: action.payload.page > 1,
        };
      })
      .addCase(fetchActivityLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, setFilters, clearFilters, setPage } = activityLogsSlice.actions;
export default activityLogsSlice.reducer;